import styled from 'styled-components'
import { Flex } from 'pcln-design-system'

export const WrapFlex = styled(Flex)`
  position: relative;
`

WrapFlex.displayName = 'WrapFlex'

export default WrapFlex
